import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Progress } from "../components/ui/progress";
import { Input } from "../components/ui/input";
import SegmentedProgress from "../components/ui/SegmantProgress";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../components/ui/tooltip";
import {
  BookOpen,
  Clock,
  CheckCircle,
  AlertCircle,
  Users,
  Play,
  Terminal,
  Calendar,
  MessageSquare,
  RefreshCw,
  Award,
  FileText,
  User,
  ExternalLink,
  ArrowLeft,
  Search,
} from "lucide-react";
import { useAuth, useNavigation } from "../App";
// import useAuth from "../components/Context/AuthContext";
// import useNavigation from "../components/Context/NavigationContext";
import { ProjectHeader } from "../components/ui/page-header";
import { toast } from "sonner";
import ProgressLegend from "../components/ui/ProgressLegend";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import paths from "../routes";
import {
  EnhancedProjectsResponseData,
  useEnhancedProjectsQuery,
} from "../api/projectManagementApi";
import { tokenService } from "../services/TokenService";
import { UseQueryOptions, QueryKey } from "@tanstack/react-query";

interface Project {
  id: string;
  title: string;
  description?: string;
  subject?: string;
  difficulty?: string;
  status: string;
  progress?: any;
  totalCheckpoints?: number;
  due_date: string | null;
  totalPoints?: number;
  grade?: string;
  sandboxStatus?: string;
  hasDataset?: boolean;
  startDate?: string | null;
  projectId?: string;
  completedCheckPointCount?: number;
  inProgressCheckPointCount?: number;
  submittedCheckPointCount?: number;
  totalCheckPoints?: number;
}

interface Progress {
  status: "pending" | "ongoing" | "submitted" | "overdue" | "graded";
  checkpoint: string;
  startDate: string;
  endDate: string;
}

// const mockProjects: Project[] = [
//   {
//     id: "proj_1",
//     title: "Gold Price Prediction",
//     description: "Build a machine learning model to predict gold prices",
//     subject: "Machine Learning",
//     difficulty: "Intermediate",
//     status: "in_progress",
//     progress: [
//       {
//         status: "submitted",
//         checkpoint: "data visualization",
//         startDate: "2025-08-01T09:00:00Z",
//         endDate: "2025-08-02T09:00:00Z",
//       },
//       {
//         status: "submitted",
//         checkpoint: "data visualization",
//         startDate: "2025-08-02T09:00:00Z",
//         endDate: "2025-08-03T09:00:00Z",
//       },
//       {
//         status: "overdue",
//         checkpoint: "data visualization",
//         startDate: "2025-08-03T09:00:00Z",
//         endDate: "2025-08-04T09:00:00Z",
//       },
//       {
//         status: "ongoing",
//         checkpoint: "data visualization",
//         startDate: "2025-08-04T09:00:00Z",
//         endDate: "2025-08-05T09:00:00Z",
//       },
//       {
//         status: "pending",
//         checkpoint: "data visualization",
//         startDate: "2025-08-05T09:00:00Z",
//         endDate: "2025-08-06T09:00:00Z",
//       },
//       {
//         status: "pending",
//         checkpoint: "data visualization",
//         startDate: "2025-08-06T09:00:00Z",
//         endDate: "2025-08-07T09:00:00Z",
//       },
//       {
//         status: "pending",
//         checkpoint: "data visualization",
//         startDate: "2025-08-07T09:00:00Z",
//         endDate: "2025-08-08T09:00:00Z",
//       },
//       {
//         status: "pending",
//         checkpoint: "data visualization",
//         startDate: "2025-08-08T09:00:00Z",
//         endDate: "2025-08-09T09:00:00Z",
//       },
//     ],
//     totalCheckpoints: 8,
//     dueDate: "2025-09-29T23:59:00Z",
//     totalPoints: 100,
//     sandboxStatus: "active",
//     hasDataset: true,
//   },
//   {
//     id: "proj_2",
//     title: "Customer Segment Analysis",
//     description:
//       "Perform clustering analysis to segment customers based on purchasing behavior.",
//     subject: "Data Analytics",
//     difficulty: "Beginner",
//     status: "submitted",
//     progress: [
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-10T10:00:00Z",
//         endDate: "2025-01-11T10:00:00Z",
//       },
//       {
//         status: "submitted",
//         checkpoint: "data visualization",
//         startDate: "2025-01-11T10:00:00Z",
//         endDate: "2025-01-12T10:00:00Z",
//       },
//       {
//         status: "overdue",
//         checkpoint: "data visualization",
//         startDate: "2025-01-12T10:00:00Z",
//         endDate: "2025-01-13T10:00:00Z",
//       },
//       {
//         status: "overdue",
//         checkpoint: "data visualization",
//         startDate: "2025-01-13T10:00:00Z",
//         endDate: "2025-01-14T10:00:00Z",
//       },
//       {
//         status: "pending",
//         checkpoint: "data visualization",
//         startDate: "2025-01-14T10:00:00Z",
//         endDate: "2025-01-15T10:00:00Z",
//       },
//       {
//         status: "pending",
//         checkpoint: "data visualization",
//         startDate: "2025-01-15T10:00:00Z",
//         endDate: "2025-01-16T10:00:00Z",
//       },
//     ],
//     totalCheckpoints: 6,
//     dueDate: "2025-01-15T23:59:00Z",
//     totalPoints: 80,
//     sandboxStatus: "stopped",
//     hasDataset: true,
//   },
//   {
//     id: "proj_3",
//     title: "Sentiment Analysis",
//     description:
//       "Build a text classification model to analyze sentiment in social media posts.",
//     subject: "Natural Language Processing",
//     difficulty: "Intermediate",
//     status: "graded",
//     progress: [
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-01T09:00:00Z",
//         endDate: "2025-01-02T09:00:00Z",
//       },
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-02T09:00:00Z",
//         endDate: "2025-01-03T09:00:00Z",
//       },
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-03T09:00:00Z",
//         endDate: "2025-01-04T09:00:00Z",
//       },
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-04T09:00:00Z",
//         endDate: "2025-01-05T09:00:00Z",
//       },
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-05T09:00:00Z",
//         endDate: "2025-01-06T09:00:00Z",
//       },
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-06T09:00:00Z",
//         endDate: "2025-01-07T09:00:00Z",
//       },
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-07T09:00:00Z",
//         endDate: "2025-01-08T09:00:00Z",
//       },
//       {
//         status: "graded",
//         checkpoint: "data visualization",
//         startDate: "2025-01-08T09:00:00Z",
//         endDate: "2025-01-09T09:00:00Z",
//       },
//     ],
//     totalCheckpoints: 8,
//     dueDate: "2025-01-18T23:59:00Z",
//     totalPoints: 90,
//     grade: "A",
//     sandboxStatus: "stopped",
//     hasDataset: true,
//   },
// ];

function ProjectCard({
  project,
  onViewProject,
  onLaunchSandbox,
}: {
  project: Project;
  onViewProject: (projectId: string) => void;
  onLaunchSandbox: (projectId: string) => void;
}) {
  const navigate = useNavigate();
  console.log(project.id);
  const handleViewProject = (e: React.MouseEvent) => {
    navigate(paths.projectDetails.replace(":projectId", project.id));
  };

  const handleLaunchSandbox = (e: React.MouseEvent) => {
    e.stopPropagation();
    onLaunchSandbox(project.id);
  };

  const getStatusDisplay = () => {
    switch (project.status) {
      case "in_progress":
        return {
          icon: <RefreshCw className="h-4 w-4" />,
          text: "In Progress",
          color: "text-bits-blue",
        };
      case "submitted":
        return {
          icon: <CheckCircle className="h-4 w-4" />,
          text: "Submitted",
          color: "text-bits-gold",
        };
      case "graded":
        return {
          icon: <Award className="h-4 w-4" />,
          text: "Graded",
          color: "text-bits-blue",
        };
      default:
        return {
          icon: <Clock className="h-4 w-4" />,
          text: "Not Started",
          color: "text-muted-foreground",
        };
    }
  };
  console.log(project);
  const getDueDateDisplay = () => {
    const now = new Date();
    const due = project.due_date ? new Date(project.due_date) : null;
    const start = project.startDate ? new Date(project.startDate) : null;

    if (!due) return { text: "No due date", isOverdue: false };

    const isOverdue = now > due;

    // Format start date
    const formattedStartDate = start
      ? `${start.getDate()} ${start.toLocaleString("default", {
          month: "short",
        })}`
      : "TBD"; // fallback if startDate is null

    // Format end date
    const formattedEndDate = `${due.getDate()} ${due.toLocaleString("default", {
      month: "short",
    })} ${due.getFullYear()}`;

    const dateRange = `${formattedEndDate}`;

    return { text: dateRange, isOverdue };
  };

  const dueDateDisplay = getDueDateDisplay();

  return (
    <Card onClick={handleViewProject} className="overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-200 border border-border rounded-lg h-full flex flex-col">
      <CardHeader className="pb-4">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-semibold pr-2 line-clamp-2">
            {project?.title}
          </CardTitle>
        </div>
        <div>
          <CardDescription className="text-sm text-muted-foreground mt-2 line-clamp-3 overflow-hidden">
            <div
              className="text-bits-grey-600
  [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-2
  [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:mb-2
  [&_li]:mb-1 [&_p]:mb-2"
              dangerouslySetInnerHTML={{
                __html: project?.description || "No description specified",
              }}
            />
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent className="pt-0 flex flex-col flex-grow overflow-visible">
        <div className="space-y-4 flex flex-col justify-between h-full overflow-visible">
          {/* Progress section */}
          <div className="space-y-2 relative">
            <span className="text-base text-muted-foreground">Progress</span>
            <SegmentedProgress
              completedCheckPointCount={project?.completedCheckPointCount || 0}
              inProgressCheckPointCount={
                project?.inProgressCheckPointCount || 0
              }
              submittedCheckPointCount={project?.submittedCheckPointCount || 0}
              totalCheckPoints={
                project?.totalCheckPoints || project?.totalCheckpoints || 0
              }
            />
          </div>
          {/* Bottom section */}
          <div className="flex items-center justify-between pt-2 mt-auto">
            <div className="flex items-center gap-1 text-sm text-muted-foreground">
              <Calendar className="h-4 w-4" />
              <span className="text-muted-foreground font-semibold">
                {dueDateDisplay?.text}
                {dueDateDisplay?.isOverdue && (
                  <span className="text-bits-red ml-1">(Overdue)</span>
                )}
              </span>
            </div>
            <Button
              onClick={handleViewProject}
              className={`bg-bits-green hover:bg-green-700 whitespace-nowrap text-white px-4 py-2 rounded-md`}
            >
              <ExternalLink className="h-4 w-4" />
              Open
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default function StudentsAllProjectsPage() {
  const { user } = useAuth();
  const { navigateTo, goBack } = useNavigation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const [searchInput, setSearchInput] = useState(searchQuery);
  const itemsPerPage = 10;
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(
    null
  );

  const handleViewProject = (projectId: string) => {
    console.log("here");
    navigate(`/project-details/${projectId}`, {
      state: { from: "view-all-projects" },
    });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchInput(value);

    // Clear existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Set new timeout for debounced search
    const timeout = setTimeout(() => {
      const newParams: Record<string, string> = { page: "1" };
      if (value.trim()) {
        newParams.search = value.trim();
      }
      setSearchParams(newParams);
    }, 500); // 500ms debounce

    setSearchTimeout(timeout);
  };

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Clear timeout and search immediately
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    const newParams: Record<string, string> = { page: "1" };
    if (searchInput.trim()) {
      newParams.search = searchInput.trim();
    }
    setSearchParams(newParams);
  };

  const clearSearch = () => {
    setSearchInput("");
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    setSearchParams({ page: "1" });
  };

  const handlePageChange = (newPage: number) => {
    const newParams: Record<string, string> = { page: newPage.toString() };
    if (searchQuery) {
      newParams.search = searchQuery;
    }
    setSearchParams(newParams);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [token, setToken] = useState<string | null>(tokenService.getToken());
  useEffect(() => {
    const unsubscribe = tokenService.subscribe((newToken) => {
      setToken(newToken);
    });

    return unsubscribe;
  }, []);

  // Cleanup search timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  const {
    data: enhancedProjectsData,
    isLoading,
    isError,
  } = useEnhancedProjectsQuery(
    {
      token,
      page: currentPage,
      limit: itemsPerPage,
      ...(searchQuery && { search: searchQuery }),
    },
    {
      onSuccess: (response: EnhancedProjectsResponseData) => {
        console.log(response, "response ins here");
        console.log("Projects fetched successfully");
      },
      onError: (err: unknown) => {
        console.log("projects error", err);
      },
      retry: false,
    } as Omit<
      UseQueryOptions<
        EnhancedProjectsResponseData,
        Error,
        EnhancedProjectsResponseData,
        QueryKey
      >,
      "queryKey" | "queryFn"
    >
  );

  const handleLaunchSandbox = (projectId: string) => {
    const project = projects.find((p) => p.id === projectId);
    if (!project) return;

    if (project.sandboxStatus === "active") {
      navigateTo("sandbox", { projectId, sandboxId: `sandbox_${projectId}` });
    } else {
      toast.success("Starting sandbox environment...", {
        description: "Your development environment is being prepared.",
      });

      setTimeout(() => {
        toast.success("Sandbox environment ready!", {
          description: "You can now start working on your project.",
        });
        navigateTo("sandbox", { projectId, sandboxId: `sandbox_${projectId}` });
      }, 3000);
    }
  };
  const navigateBack = () => {
    navigate(paths.root);
  };

  // Get pagination data
  const totalPages = enhancedProjectsData?.pagination?.totalPages || 1;
  const totalItems = enhancedProjectsData?.pagination?.totalItems || 0;
  const projects = enhancedProjectsData?.projects || [];

  console.log(enhancedProjectsData);
  return (
    <div className="p-6 bg-gray-50 min-h-screen space-y-6">
      <ProjectHeader title="All Projects" onBackClick={navigateBack}>
        <ProgressLegend
          className="flex flex-wrap items-center gap-5 mx-4 text-xs text-muted-foreground"
          barWidth="w-6"
          barHeight="h-1"
        />
      </ProjectHeader>

      {/* Search Bar */}
      <div className="flex items-center gap-3">
        <form onSubmit={handleSearchSubmit} className="flex-1 max-w-2xl">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
              type="text"
              placeholder="Search projects by title, description, or subject..."
              value={searchInput}
              onChange={handleSearchChange}
              className="pl-10 pr-10"
            />
            {searchInput && (
              <button
                type="button"
                onClick={clearSearch}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                ×
              </button>
            )}
          </div>
        </form>
        {searchQuery && (
          <div className="text-sm text-gray-600">
            Found {totalItems} project{totalItems !== 1 ? "s" : ""}
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 gap-8">
        {isLoading ? (
          <div className="col-span-2 flex justify-center items-center p-6">
            <p className="text-gray-700 text-lg">Loading projects...</p>
          </div>
        ) : isError ? (
          <div className="col-span-2 flex flex-col justify-center items-center p-6">
            <p className="text-red-600 text-lg">Failed to load projects.</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Retry
            </button>
          </div>
        ) : !projects?.length ? (
          <div className="col-span-2 flex justify-center items-center p-6">
            <p className="text-gray-500 text-lg">
              {searchQuery
                ? `No projects found matching "${searchQuery}"`
                : "No projects found."}
            </p>
          </div>
        ) : (
          projects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              onViewProject={handleViewProject}
              onLaunchSandbox={handleLaunchSandbox}
            />
          ))
        )}
      </div>

      {/* Pagination */}
      {!isLoading && !isError && projects.length > 0 && totalPages > 1 && (
        <div className="flex items-center justify-between mt-6 px-4">
          <div className="text-sm text-gray-600">
            Page {currentPage} of {totalPages} ({totalItems} total projects)
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-3 py-2"
            >
              Previous
            </Button>

            {/* Page Numbers */}
            <div className="flex gap-1">
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNum;
                if (totalPages <= 5) {
                  pageNum = i + 1;
                } else if (currentPage <= 3) {
                  pageNum = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNum = totalPages - 4 + i;
                } else {
                  pageNum = currentPage - 2 + i;
                }

                return (
                  <Button
                    key={pageNum}
                    variant={currentPage === pageNum ? "default" : "outline"}
                    size="sm"
                    onClick={() => handlePageChange(pageNum)}
                    className={`w-10 h-10 ${
                      currentPage === pageNum
                        ? "bg-bits-blue hover:bg-bits-blue/90"
                        : ""
                    }`}
                  >
                    {pageNum}
                  </Button>
                );
              })}
            </div>

            <Button
              variant="outline"
              size="sm"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-3 py-2"
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
